module.exports = __webpack_public_path__ + "img/chevron-left.181a4e1b.svg";